import React from 'react';
import styled from 'styled-components';
import { AlertTriangle, Info } from 'lucide-react';

import { theme } from '../../styles/theme';

interface QualityHintsProps {
  warnings?: string[];
  infos?: string[];
}

const Container = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Hint = styled.div<{ $variant: 'warning' | 'info' }>`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: ${theme.typography.fontSize.sm};
  background: ${({ $variant }) =>
    $variant === 'warning' ? `${theme.colors.accent.peach}20` : `${theme.colors.primary[100]}50`};
  border-radius: ${theme.borderRadius.lg};
  padding: 0.6rem 0.75rem;
  color: ${theme.colors.text.primary};

  svg {
    flex-shrink: 0;
    margin-top: 0.1rem;
    color: ${({ $variant }) =>
      $variant === 'warning' ? theme.colors.accent.peach : theme.colors.primary[500]};
  }
`;

export const QualityHints: React.FC<QualityHintsProps> = ({ warnings = [], infos = [] }) => {
  if (warnings.length === 0 && infos.length === 0) {
    return null;
  }

  return (
    <Container>
      {warnings.map((warning, index) => (
        <Hint key={`warning-${index}`} $variant="warning">
          <AlertTriangle size={16} />
          <span>{warning}</span>
        </Hint>
      ))}
      {infos.map((info, index) => (
        <Hint key={`info-${index}`} $variant="info">
          <Info size={16} />
          <span>{info}</span>
        </Hint>
      ))}
    </Container>
  );
};


